import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiCookieCategoryDTO,
  CookieCategoryDTO,
} from "@lib/strapi/dtos/components/cookies/cookieCategory.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export class CookieCategoryService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiCookieCategoryDTO,
  ): Promise<CookieCategoryDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new CookieCategoryDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.title = strapiData.title;
    dto.slug = strapiData.slug;
    dto.description = await parseStrapiContent(strapiData.description);
    dto.signalGroup = strapiData.signalGroup;
    dto.disabled = strapiData.disabled;
    dto.preSelected = strapiData.preSelected;
    return dto;
  }
}
